module.exports = __webpack_public_path__ + "static/w-finastra-account-based-marketing-1c9dd3dc2d89d587167423721891a691.webp";